import { CustomHamper } from 'components/mobile/organisms';

export const CustomHamperMobileSlot = () => {
  return <CustomHamper />;
};
